import { lazy } from 'react';

const AuditLockApprovalComponent = lazy(() =>
  import('../pages/AuditLock/Approval'),
);

const auditLockApprovalRoute = {
  auth: [
    {
      name: 'audit_lock_approval',
      path: '/audit-lock/approval',
      component: AuditLockApprovalComponent,
    },
  ],
};

export default auditLockApprovalRoute;
